import { utcMinutesOffset } from '@lingoda/dates';

export const formatRangeHour = (hour: number) =>
    `${hour.toString().padStart(2, '0')}:${utcMinutesOffset().toString().padStart(2, '0')}`;
